import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { usePageHeader } from "Shared/Layouts/PageHeaderContext";

const DEV_PLACEHOLDER = "TODO: Dashboard UI";

export const DashboardPage = () => {
	const { t } = useResource();
	usePageHeader({
		title: t(Resources.Dashboard.Heading),
		subtitle: t(Resources.Dashboard.Description),
	});

	return (
		<div className="text-muted-foreground flex h-full items-center justify-center text-label">
			{DEV_PLACEHOLDER}
		</div>
	);
};
